import React, { useEffect, useState } from "react";
import { Modal, Row } from "rsuite";
import { EPTable } from "../../../common/controls";
import { axiosGet } from "../../../common/utils/helper";
import { AxiosResponse } from "axios";
import {  getCandidateStatusLogById, getRequirementList } from "../../../common/utils/api";
import { CommonConstants } from "../../../common/utils/CommonConstants";

interface Props {
  openViewCandidateHistory: boolean;
  setOpenViewCandidateHistory: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
  
}

export default function ViewCandidateHistoryModal(props: Props) {
  const { data, setOpenViewCandidateHistory, openViewCandidateHistory } = props;
  const [candidateHistoryData, setCandidateHistoryData] = useState<any>({});

  const tableColumns: any = [
    {
      key: "RequirementName",
      label: "Request Title",
      width: 120,
      resizable: true,
    },    
    {
      key: "Round",
      label: "Round",
      resizable: true,
      width: 110
    },
    {
      key: "StatusUpdatedDate",
      label: "Date",
      resizable: true,
      width: 110
    },
    {
      key: "Status",
      label: "Status",
      resizable: true,
      width: 160
    },
    {
      key: "PrimaryInterviewer",
      label: "Interviewer",
      resizable: true,
      width: 160
    },
    {
      key: "HRComments",
      label: "Remarks",
      resizable: true,
      width: 200
    },
    {
      key: "Feedback",
      label: "FeedBack",
      resizable: true,
      width: 80,
      // flexGrow: 1,
    },
  ];

  function closeModal() {
    setOpenViewCandidateHistory(false);
  }
 
  useEffect(() => {
    getCandidateHistoryById(`${getCandidateStatusLogById}/${data.CandidateId}`);
  }, []);

  async function getCandidateHistoryById(reqUrl: string) {
    const response = (await axiosGet(reqUrl, {})) as AxiosResponse;
    if (response && response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
      setCandidateHistoryData(response.data.data.result);
    }
  }
 
  return (
    <Modal
      open={openViewCandidateHistory}
      onClose={closeModal}
      className="modal-lg"
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
        Candidate History - {`${data.FirstName? data?.FirstName : data?.Candidate}`}{" "}
    {data.lastName ? null : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
        <EPTable
          columns={tableColumns}
          rowHeight={45}
          listName="manageCandidateHistory"
          data={candidateHistoryData}
          // refresher={refresher}
          // setRefresher={setRefresher}
        />
        </Row>
      </Modal.Body>
    </Modal>
  );
}
